import React from 'react';
import styled, { css } from 'styled-components';

import { placeholderAnimationCss } from '@tager/web-components';

import { media } from '@/utils/mixin';

function BadgesPlaceholder() {
  return (
    <Component>
      <Badge />
      <Badge />
    </Component>
  );
}

export default BadgesPlaceholder;

const Component = styled.div`
  margin-top: 15px;
  display: flex;
`;

const Badge = styled.div`
  width: 100px;
  height: 32px;
  border-radius: 32px;
  margin: 0 5px 5px 0;
  ${placeholderAnimationCss}

  ${media.laptopOnly(css`
    height: 28px;
  `)}

  ${media.tablet(css`
    height: 24.1px;
  `)}
`;
